import { Grid } from "@mui/material";

import { AccessControlCard } from "features/public-api";
import { SolutionOverview } from "features/solution";
import {
  AdminConsoleCard,
  RestrictedTenantRealm,
  TenantPermission
} from "features/tenant";

import { WorkspacesCard } from "features/workspace";

export default function LandingPage() {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <SolutionOverview />
      </Grid>
      <Grid container spacing={4} padding={4}>
        <RestrictedTenantRealm
          requiredPermissions={[TenantPermission.ReadApiKeys]}
          silent={true}
        >
          <Grid item>
            <AccessControlCard />
          </Grid>
        </RestrictedTenantRealm>
        <RestrictedTenantRealm
          requiredPermissions={[TenantPermission.ReadWorkspaces]}
          silent={true}
        >
          <Grid item>
            <WorkspacesCard />
          </Grid>
        </RestrictedTenantRealm>
        <RestrictedTenantRealm
          requiredPermissions={[TenantPermission.ChangeTenantMemberPermissions]}
          silent={true}
        >
          <Grid item>
            <AdminConsoleCard />
          </Grid>
        </RestrictedTenantRealm>
      </Grid>
    </Grid>
  );
}
